import React from 'react';
import { Container } from '../ui/Container';
import { XIcon, CheckIcon } from 'lucide-react';
export const ProblemSection: React.FC = () => {
  const problems = [{
    title: 'Brokers flood the market',
    description: 'Brokers shop the same deals to 10+ buyers forcing you to compete in auctions and overpay for deals.'
  }, {
    title: 'Finder networks recycle leads',
    description: 'The same "exclusive" opportunities get shopped to everyone in their rolodex.'
  }, {
    title: 'Cold outreach is conversion poor',
    description: 'Every decent business has 20+ buyers in their inbox. Making 200 cold calls to drum up one decent opportunity is wildly inefficient.'
  }, {
    title: 'Relying on referrals is inconsistent',
    description: "Referrals are great but you can't build a predictable pipeline or forecast deal volume with certainty."
  }];
  const advantages = [{
    title: 'See deals first',
    description: 'Reach motivated sellers weeks or months before they talk to a broker.'
  }, {
    title: 'See deals exclusively',
    description: 'No auctions. No competitive bid-ups. Just you and the seller.'
  }, {
    title: 'Buy at better valuations',
    description: 'Our clients typically see 5-15% discounts compared to brokered deals.'
  }, {
    title: 'Build a predictable pipeline',
    description: 'Put your investment thesis in front of thousands of qualified owners, 24/7.'
  }];
  return <section className="w-full bg-dark-900 py-24 md:py-32 relative overflow-hidden" data-id="element-649">
      <div className="absolute inset-0 bg-gradient-to-b from-dark-800/50 via-transparent to-dark-800/50" data-id="element-650" />
      <Container className="relative" data-id="element-651">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20" data-id="element-652">
          {/* Problems Column */}
          <div className="flex flex-col" data-id="element-653">
            <div className="mb-10 lg:h-24 flex flex-col justify-end" data-id="element-654">
              <p className="text-red-400 font-medium text-sm tracking-wide uppercase mb-3" data-id="element-655">
                The Problem
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-[28px] xl:text-3xl font-bold text-white leading-tight" data-id="element-656">
                Traditional Deal Sourcing Is Broken
              </h2>
            </div>

            <div className="space-y-4 flex-1" data-id="element-657">
              {problems.map((problem, index) => <div key={index} className="group relative bg-dark-800/60 border border-dark-600/50 rounded-xl p-5 transition-all duration-200 lg:min-h-[100px]" data-id="element-658">
                  <div className="flex gap-4" data-id="element-659">
                    <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-red-500/10 border border-red-500/20" data-id="element-660">
                      <XIcon className="w-4 h-4 text-red-400" data-id="element-661" />
                    </div>
                    <div data-id="element-662">
                      <h3 className="text-white font-semibold mb-1" data-id="element-663">
                        {problem.title}
                      </h3>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-664">
                        {problem.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>

            <p className="mt-8 text-gray-400 text-base pl-1" data-id="element-665">
              You're chasing the same deals as everyone else, and paying more
              for the privilege.
            </p>
          </div>

          {/* Advantages Column */}
          <div className="flex flex-col" data-id="element-666">
            <div className="mb-10 lg:h-24 flex flex-col justify-end" data-id="element-667">
              <p className="text-[#00c853] font-medium text-sm tracking-wide uppercase mb-3" data-id="element-668">
                The Solution
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-[28px] xl:text-3xl font-bold text-white leading-tight" data-id="element-669">
                The Deal Flow Advantage
              </h2>
            </div>

            <div className="space-y-4 flex-1" data-id="element-670">
              {advantages.map((advantage, index) => <div key={index} className="group relative bg-dark-800/60 border border-[#00c853]/20 rounded-xl p-5 transition-all duration-200 lg:min-h-[100px]" data-id="element-671">
                  <div className="flex gap-4" data-id="element-672">
                    <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-[#00c853]/10 border border-[#00c853]/20" data-id="element-673">
                      <CheckIcon className="w-4 h-4 text-[#00c853]" data-id="element-674" />
                    </div>
                    <div data-id="element-675">
                      <h3 className="text-white font-semibold mb-1" data-id="element-676">
                        {advantage.title}
                      </h3>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-677">
                        {advantage.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>

            <p className="mt-8 text-gray-400 text-base pl-1" data-id="element-678">
              The only sourcing model that delivers volume, control, and
              efficiency without relying on luck or intermediaries.
            </p>
          </div>
        </div>
      </Container>
    </section>;
};